import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventViewModel } from '../_models/generatedModels';
import { AnalyticsService } from '../_services/analytics.service';
import { AuthenticationService } from '../_services/authentication.service';
import { OrganizationService, UserService } from '../_services/generatedServices';
import { NavigationService } from '../_services/navigation-service';
import { SettingsProvider } from '../_services/settingsProvider.service';

@Component({
  selector: 'bxl-reservations',
  templateUrl: 'reservations.component.html',
})
export class ReservationsComponent implements OnInit {
  initialized = false;
  slug = "";
  events: EventViewModel[];
  constructor(public auth: AuthenticationService, public title: AnalyticsService, public settings: SettingsProvider, private route: ActivatedRoute, private router: Router, public nav: NavigationService, public userService: UserService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      this.slug = param.get('conferenceSlug');

      if (!this.auth.isLoggedIn()){
        this.initialized = true;
        return;
      }

      this.userService.getConferenceEventReservations(this.slug).subscribe((reservations) => {
        this.events = reservations;
        this.initialized = true;
      });
    });
  }
}
